import { useState } from "react";
import { Apple, Play, ChevronDown } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { IncidenciaButton } from "@/components/landing/IncidenciaButton";

const IOS_URL = "https://apps.apple.com/es/app/fynkus-administraci%C3%B3n-fincas/id1257645322";
const ANDROID_URL = "https://play.google.com/store/apps/details?id=fynkus.administracionfincas";

export const PropietariosButton = ({ testId, label = "Portal del Propietario", dark = false, large = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        data-testid={testId}
        onClick={() => setOpen(true)}
        className={`inline-flex items-center justify-center gap-1.5 font-semibold rounded-full transition-all duration-300 hover:-translate-y-0.5 ${
          large ? "text-base px-9 py-4" : "text-sm px-5 py-2.5"
        } ${
          dark
            ? "text-white border border-white/25 hover:bg-white hover:text-slate-900"
            : "text-slate-900 border border-slate-300 hover:border-slate-900"
        }`}
      >
        {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="propietarios-modal" className="max-w-xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl tracking-tight">Portal del Propietario</DialogTitle>
            <DialogDescription>Tu comunidad con trazabilidad total. Elige tu vía de acceso:</DialogDescription>
          </DialogHeader>

          <div className="space-y-4 mt-2">
            <div className="border border-slate-900 rounded-xl p-6 bg-white" data-testid="modal-opcion-incidencia">
              <h3 className="font-display font-semibold text-lg text-slate-900">Comunicación de Averías</h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">
                Notifica incidencias comunitarias con fotografía sin necesidad de iniciar sesión.
              </p>
              <div className="mt-5">
                <IncidenciaButton testId="modal-incidencia-btn" label="Notificar Incidencia Web" onClose={() => setOpen(false)} />
              </div>
            </div>

            <div className="border border-slate-200 rounded-xl p-6 bg-slate-50" data-testid="modal-opcion-portal">
              <h3 className="font-display font-semibold text-lg text-slate-900">Descarga de la App de Propietarios</h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">
                Gestiona recibos, actas y convocatorias desde tu móvil.
              </p>
              <div className="mt-5 flex gap-2.5">
                <a
                  href={IOS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="modal-download-ios"
                  className="flex-1 inline-flex items-center justify-center gap-2 bg-slate-900 text-white text-xs font-semibold rounded-full px-4 py-2.5 hover:bg-slate-800 transition-colors duration-300"
                >
                  <Apple className="w-3.5 h-3.5" /> App Store
                </a>
                <a
                  href={ANDROID_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="modal-download-android"
                  className="flex-1 inline-flex items-center justify-center gap-2 border border-slate-300 text-slate-900 text-xs font-semibold rounded-full px-4 py-2.5 hover:border-slate-900 transition-colors duration-300"
                >
                  <Play className="w-3.5 h-3.5" /> Google Play
                </a>
              </div>
            </div>

            <details className="border border-slate-200 rounded-xl bg-white group" data-testid="modal-instrucciones">
              <summary className="cursor-pointer list-none flex items-center justify-between p-5 text-sm font-semibold text-slate-900 hover:text-slate-600 transition-colors duration-300">
                Instrucciones de alta e instalación
                <ChevronDown className="w-4 h-4 text-slate-400 transition-transform duration-300 group-open:rotate-180" />
              </summary>
              <ol className="px-5 pb-5 space-y-2.5 text-sm text-slate-500 list-decimal list-inside leading-relaxed">
                <li>Descarga la App 'Fynkus' desde tu tienda móvil.</li>
                <li>Regístrate con el correo electrónico registrado en la administración.</li>
                <li>Introduce el código de verificación recibido en tu email.</li>
                <li>Accede al menú superior para consultar tu comunidad.</li>
              </ol>
            </details>
          </div>

          <p className="mt-6 text-center text-xs text-slate-400">
            ¿Dudas con tus credenciales? Escríbenos a{" "}
            <a href="mailto:gestiones@afgestiones.es" className="underline underline-offset-2 hover:text-slate-600 transition-colors duration-300">
              gestiones@afgestiones.es
            </a>
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
};
